<div>
  <p-fieldset legend="Ändra {{membership?.institution.shortName}} {{membership?.institution.name}}">
    <form [formGroup]="editmembershipform">
      <div class="row">
        <div class="form-group col-md-3">
          <label>Institution</label>
          <div>{{membership?.institution.shortName}} {{membership?.institution.name}}</div>
        </div>
        <div class="form-group col-md-8">
          <label>Medlemsnummer</label>
          <div>{{membership?.memberId}}</div>
        </div>
      </div>
      <div style="width:100%;border:1px solid #F0F0F0;"></div>
      <div class="row" style="margin-top:10px;">
        <div class="form-group col-md-3">
          <label for="startDate">Från datum</label>
          <app-calendar [form]="editmembershipform" formName="startDate" [required]=true></app-calendar>
        </div>
        <div class="form-group col-md-8">
          <label for="startCauseId">Införandeanledning</label>
          <select class="form-control form-control-sm" id="startCauseId" formControlName="startCauseId" required>
            <option></option>
            <option *ngFor="let e of enterexitcauses" [ngValue]="e.id">{{e.description}}</option>
          </select>
        </div>
      </div>
      <div *ngIf="selectedrole?.userDomain!=='LODGE'&&selectedrole?.userDomain!=='CAMP'&&selectedrole?.userPermissionLevel!=='IN' && editmembershipform.get('endDate').value!=='9999-12-31'" class="row">
        <div class="form-group col-md-3">
          <label for="toDate">Till datum</label>
          <app-calendar [form]="editmembershipform" formName="endDate" [required]=true></app-calendar>
          <button class="btn border mt-2" (click)="setEndDate()">Tillsvidare</button>
        </div>
        <div class="form-group col-md-8">
          <label for="endCauseId">Upphörandeanledning</label>
          <select class="form-control form-control-sm" id="endCauseId" formControlName="endCauseId">
            <option></option>
            <option *ngFor="let e of enterexitcauses" [ngValue]="e.id">{{e.description}}</option>
          </select>
        </div>
      </div>
    </form>
    <br>
    <div class="d-flex justify-content-start">
      <button class="btn border" (click)="save()">Spara</button>
      <button class="btn border ms-2" (click)="close()">Avbryt</button>
    </div>
    
  </p-fieldset>
</div>